export default __webpack_public_path__ + "static/media/image26.57399033.svg";